// Tipos de caja/cuenta (m_erp_finances_cash.kind)
// tone: color del tema con el que se identifica el tipo (success, primary, warning, info, neutral)
const CASH_KINDS = [
  { value: 'CASH', text: 'Caja efectivo', icon: 'payments', tone: 'success' },
  { value: 'BANK', text: 'Cuenta corriente bancaria', icon: 'account_balance', tone: 'primary' },
  { value: 'POSNET', text: 'Posnet / tarjetas', icon: 'credit_card', tone: 'warning' },
  { value: 'WALLET', text: 'Billetera virtual', icon: 'account_balance_wallet', tone: 'info' },
  { value: 'INVESTMENT', text: 'Inversión', icon: 'trending_up', tone: 'info' },
  { value: 'RETENTION', text: 'Retenciones', icon: 'receipt_long', tone: 'warning' },
  // OTHER va último: es el valor por defecto de cashKindOf()
  { value: 'OTHER', text: 'Otra', icon: 'category', tone: 'neutral' },
]

export function cashKindOf(value) {
  return CASH_KINDS.find(k => k.value === value) || CASH_KINDS[CASH_KINDS.length - 1]
}

export default CASH_KINDS
